import { useMutation } from "urql";

import { UpdateLimitRequestInlineDocument } from "../../../graphql/generated.ts";

export function useUpdateLimitRequestInline() {
  return useMutation(UpdateLimitRequestInlineDocument);
}
